var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObRecheckEndCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fff",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#OBRecheckEndCall_svg__clip0_4468_7422)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 9.333A6.667 6.667 0 009.334 16a.833.833 0 01-1.667 0 8.333 8.333 0 0114.167-5.951v-.716a.833.833 0 111.666 0v3.225a.833.833 0 01-1.01.815l-3.333-.725a.833.833 0 11.354-1.629l1.197.26A6.645 6.645 0 0016 9.333zM23.5 15.167c.46 0 .834.373.834.833a8.333 8.333 0 01-14.167 5.951v.716a.833.833 0 11-1.667 0v-3.225a.833.833 0 011.01-.815l3.334.725a.833.833 0 01-.354 1.629l-1.197-.26A6.667 6.667 0 0022.667 16c0-.461.373-.834.833-.834z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "OBRecheckEndCall_svg__clip0_4468_7422"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(180 12.167 12.167)",
    d: "M0 0h16.667v16.667H0z"
  })))));
}

export default SvgObRecheckEndCall;